export const API_URL = process.env.REACT_APP_DS_API_URL;
export const SENDER_UI_URL = process.env.REACT_APP_DS_SENDER_UI_URL;
export const DS3_ENV = process.env.ENV_NAME;
export const LAUNCH_DARKLY_CLIENT_ID = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID!;

export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 5;
export const ZOOM_INCREMENT = 0.25;
export const DEFAULT_ZOOM = 1.5;
export const MD_MEDIA_QUERY = '(max-width:1024px)';
export const SKELETON_WIDTH = 8.5 * 72;
export const SKELETON_HEIGHT = 11 * 72;

export enum Events {
  ENVELOPE_SUBMITTED = 'envelopeSubmitted',
  ENVELOPE_COMPLETED = 'envelopeCompleted',
  ENVELOPE_RETRIEVED = 'envelopeRetrieved',
  ENVELOPE_CANCELED = 'envelopeCanceled',
  ENVELOPE_CORRECTING = 'envelopeCorrecting',
  EXIT_SIGNING = 'exit',
  BLOCK_CLICKED = 'blockClicked',
  ERROR = 'error',
  EXIT_SIGNING_EXPERIENCE = 'exitSigningExperience',
}

export enum PostWindowMessageStatus {
  DIGISIGN_PREPARE_FOR_SIGNATURE = 'digisign-prepare-for-signature',
  DIGISIGN_READY_TO_SEND = 'digisign-ready-to-send',
  SIGNING_TO_SET_SIGNATURE = 'signing_to_set_signature',
  SIGNING_IN_PROGRESS = 'signing-in-progress',
  SIGNING_COMPLETE = 'signing-complete',
  SIGNING_CLOSE = 'signing-close',
  SET_SIGNATURE_INCOMPLETE = 'set-signature-incomplete',
  SET_SIGNATURE_COMPLETE = 'set-signature-complete',
  SET_SIGNATURE_WINDOW_OPEN = 'set-signature-window-open',
}

// DigiSign.Sender.Envelope.Application/Requests/Queries/GetEnvelopeForSigner/ErrorCode.cs
export const ErrorCodes = {
  23423: Events.ENVELOPE_CANCELED,
  75234: Events.ENVELOPE_CORRECTING,
};

/**
 * Match BlockTypes from Signer Service
 */
export enum BlockTypes {
  SIGNATURE = 'Signature',
  DATE_SIGNED = 'DateSigned',
  INITIALS = 'Initials',
  TEXT = 'Text',
  CHECKBOX = 'Checkbox',
  FULLNAME = 'FullName',
  TIME_SIGNED = 'TimeSigned',
}

export enum BlockStatus {
  COMPLETE = 'Complete',
  DRAFT = 'Draft', // TODO : Will only see pending, remove when response body changes
  PENDING = 'Pending',
}

export enum EnvelopeStatus {
  COMPLETE = 'Completed',
  IN_PROGRESS = 'InProgress',
  DECLINED = 'Declined',
}

export enum SignerStatus {
  COMPLETE = 'Complete',
  IN_PROGRESS = 'InProgress',
  DECLINED = 'Declined',
}

export const IS_MOBILE = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const IS_IPAD = /iPad/i.test(navigator.platform);
export const IS_ANDROID = /android/i.test(navigator.userAgent);
export const IS_IOS_CHROME = navigator.userAgent.match('CriOS');
export const IS_IOS_FIREFOX = navigator.userAgent.match('FxiOS');
export const IS_IE = navigator.userAgent.match(/MSIE|Trident/);

export const SIGNATURE_FONTS = {
  Damion: {
    fontFamily: `'Damion', cursive`,
  },
  DancingScript: {
    fontFamily: `'Dancing Script', cursive`,
  },
  LaBelleAurore: {
    fontFamily: `'La Belle Aurore', cursive`,
  },
  Satisfy: {
    fontFamily: `'Satisfy', cursive`,
  },
  Vibur: {
    fontFamily: `'Vibur', cursive`,
  },
};
